import {createContext} from 'react';
import {IProdutosContext,IProps} from '../../interfaces/storage/contexts/IProdutosContext';
const produtoContextDefault : IProdutosContext =
{
    produtoContratos:[]
}

export const ProdutosContext = createContext<IProps>({produtosContext:produtoContextDefault, setProdutosContext:undefined});